import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Lock } from "lucide-react";
import { SITE } from "../lib/api";

const links = [
  { to: "/", label: "Início" },
  { to: "/trajetoria", label: "Trajetória" },
  { to: "/projetos", label: "Projetos" },
  { to: "/plano-de-governo", label: "Plano" },
  { to: "/vitrine", label: "Vitrine" },
  { to: "/noticias", label: "Notícias" },
  { to: "/contato", label: "Contato" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md border-b border-neutral-200" : "bg-white/70 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-3 group">
          <span className="inline-flex items-center justify-center w-9 h-9 bg-[#003F88] text-white font-serif-display text-xl font-semibold leading-none">
            R
          </span>
          <div className="leading-tight">
            <div className="font-serif-display text-lg md:text-xl font-semibold tracking-tight text-neutral-900">
              Antônio Rosalvo
            </div>
            <div className="text-[10px] md:text-xs uppercase tracking-[0.18em] text-neutral-500">
              {SITE.party} · Lauro de Freitas
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `nav-link text-sm uppercase tracking-wider font-medium text-neutral-800 ${
                  isActive ? "active text-[#003F88]" : ""
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contato"
            data-testid="nav-cta-participate"
            className="bg-[#003F88] text-white text-xs uppercase tracking-widest font-medium px-5 py-3 hover:bg-[#002A5C] transition-colors"
          >
            Participe
          </Link>
          <Link
            to="/admin/login"
            data-testid="nav-admin-login"
            aria-label="Acesso interno"
            className="text-neutral-500 hover:text-[#003F88] transition-colors"
            title="Acesso interno"
          >
            <Lock size={16} />
          </Link>
        </nav>

        <button
          aria-label="Abrir menu"
          data-testid="navbar-mobile-toggle"
          className="md:hidden p-2 text-neutral-900"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-neutral-200">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mnav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-base font-medium ${isActive ? "text-[#003F88]" : "text-neutral-800"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contato"
              data-testid="mnav-cta"
              className="bg-[#003F88] text-white text-xs uppercase tracking-widest font-medium px-5 py-3 text-center"
            >
              Participe
            </Link>
            <NavLink
              to="/admin/login"
              data-testid="mnav-admin"
              className="text-sm font-medium text-neutral-500 inline-flex items-center gap-2"
            >
              <Lock size={14} /> Acesso interno
            </NavLink>
          </div>
        </div>
      )}
    </header>
  );
}
